// removed by extract-text-webpack-plugin
module.exports = {"action-panel":"action-panel"};


//////////////////
// WEBPACK FOOTER
// ./components/promotion/_PromotionBox.scss
// module id = ./components/promotion/_PromotionBox.scss
// module chunks = 1